









































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { DateTime } from 'luxon'
import IconRule1 from '../../assets/images/modal-charter-rules/rule_1.svg'
import IconRule2 from '../../assets/images/modal-charter-rules/rule_2.svg'
import IconRule3 from '../../assets/images/modal-charter-rules/rule_3.svg'
import IconRule4 from '../../assets/images/modal-charter-rules/rule_4.svg'
import IconRule5 from '../../assets/images/modal-charter-rules/rule_5.svg'
import IconRule6 from '../../assets/images/modal-charter-rules/rule_6.svg'
import TranslationModule from '@/utils/TranslationModule'
import ModalName from '@/utils/ModalName'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import { ButtonTheme, ButtonSize } from '@/utils/ButtonAttr'
import store from '@/store/store'
import { Member } from '@/types/Member.type'
import API from '@/services/API'

const user = namespace('user')

@Component({
    name: 'ModalCharterLeClub',
    components: { BaseButton },
})
export default class ModalCharterLeClub extends Vue {
    @Prop({ default: ModalName.CHARTER_LECLUB }) name!: string
    @user.Getter isConnected!: boolean
    @user.Getter isCommunity!: boolean
    @user.Getter isLead!: boolean
    @user.State me!: Member
    ButtonTheme = ButtonTheme
    ButtonSize = ButtonSize

    rules = [
        {
            icon: IconRule1,
            text: this.$trans('modal.charter.rule_1', TranslationModule.COMMON),
        },
        {
            icon: IconRule2,
            text: this.$trans('modal.charter.rule_2', TranslationModule.COMMON),
        },
        {
            icon: IconRule3,
            text: this.$trans('modal.charter.rule_3', TranslationModule.COMMON),
        },
        {
            icon: IconRule4,
            text: this.$trans('modal.charter.rule_4', TranslationModule.COMMON),
        },
        {
            icon: IconRule5,
            text: this.$trans('modal.charter.rule_5', TranslationModule.COMMON),
        },
        {
            icon: IconRule6,
            text: this.$trans('modal.charter.rule_6', TranslationModule.COMMON),
        },
    ]

    @Watch('$route')
    onRouteChange() {
        this.openModal()
    }

    @Watch('me')
    openModal() {
        if (
            this.me &&
            this.isConnected &&
            !this.isLead &&
            !this.me.charter_accepted_at &&
            !window.location.pathname.startsWith('/update-account') &&
            !window.location.pathname.startsWith('/login') &&
            !window.location.pathname.startsWith('/register') &&
            !window.location.pathname.startsWith('/logout') &&
            !window.location.pathname.startsWith('/member/me') &&
            // Same role check as in security.yml : /accept-cgv
            (store.getters['user/hasRole']('ROLE_BL_LECLUB') ||
                store.getters['user/hasRole']('ROLE_BL_LECLUB_PARTNER_CONTACT'))
        ) {
            this.$modal.show(this.name)
        }
    }

    async accept() {
        try {
            this.$modal.hide(this.name)
            const charterAcceptedAt = DateTime.now().toFormat('dd/MM/yyyy HH:mm')

            await API.patchMe({ charterAcceptedAt })
            const me = await this.$store.dispatch('user/getMe')
            await this.$store.dispatch('user/setMe', {
                ...me,
                charter_accepted_at: charterAcceptedAt,
            })
        } catch (e) {
            console.error(e)
        }
    }
}
